import PropTypes from "prop-types";
import React, { useEffect } from "react";
import withRouter from "../Common/withRouter";
import { useLocation } from "react-router-dom";
import {
  changeLayout,
  changeLayoutMode,
  changeSidebarTheme,
  changeSidebarThemeImage,
  changeSidebarType,
  changeTopbarTheme,
  changeLayoutWidth,
  showRightSidebarAction
} from "../../store/actions";

// Layout Related Components
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import RightSidebar from "../CommonForBoth/RightSidebar";
import SpaAssistant from "../CommonForBoth/SpaAssistant";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';

const Layout = props => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [manualOverride, setManualOverride] = React.useState(false);

  const selectLayoutProperties = createSelector(
    (state) => state.Layout,
    (layout) => ({
      isPreloader: layout.isPreloader,
      layoutModeType: layout.layoutModeType,
      leftSideBarThemeImage: layout.leftSideBarThemeImage,
      leftSideBarType: layout.leftSideBarType,
      layoutWidth: layout.layoutWidth,
      topbarTheme: layout.topbarTheme,
      showRightSidebar: layout.showRightSidebar,
      leftSideBarTheme: layout.leftSideBarTheme,
    }));

  const {
    isPreloader,
    leftSideBarThemeImage,
    layoutWidth,
    leftSideBarType,
    topbarTheme,
    showRightSidebar,
    leftSideBarTheme,
    layoutModeType
  } = useSelector(selectLayoutProperties);

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);


  const toggleMenuCallback = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarType("condensed", isMobile));
    } else if (leftSideBarType === "condensed") {
      dispatch(changeSidebarType("default", isMobile));
    }
    // Set manual override when user manually toggles
    setManualOverride(true);
  };

  //hides right sidebar on body click
  const hideRightbar = (event) => {
    var rightbar = document.getElementById("right-bar");
    //if clicked in inside right bar, then do nothing
    if (rightbar && rightbar.contains(event.target)) {
      return;
    } else {
      //if clicked in outside of rightbar then fire action for hide rightbar
      dispatch(showRightSidebarAction(false));
    }
  };

  /*
  layout  settings
  */

  useEffect(() => {
    //init body click event fot toggle rightbar
    document.body.addEventListener("click", hideRightbar, true);


  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(changeLayout("vertical"));
  }, [dispatch]);

  useEffect(() => {
    if (leftSideBarTheme) {
      dispatch(changeSidebarTheme(leftSideBarTheme));
    }
  }, [leftSideBarTheme, dispatch]);

  useEffect(() => {
    if (layoutModeType) {
      dispatch(changeLayoutMode(layoutModeType));
    }
  }, [layoutModeType, dispatch]);

  useEffect(() => {
    if (leftSideBarThemeImage) {
      dispatch(changeSidebarThemeImage(leftSideBarThemeImage));
    }
  }, [leftSideBarThemeImage, dispatch]);

  useEffect(() => {
    if (layoutWidth) {
      dispatch(changeLayoutWidth(layoutWidth));
    }
  }, [layoutWidth, dispatch]);

  useEffect(() => {
    if (leftSideBarType) {
      dispatch(changeSidebarType(leftSideBarType));
    }
  }, [leftSideBarType, dispatch]);

  useEffect(() => {
    if (topbarTheme) {
      dispatch(changeTopbarTheme(topbarTheme));
    }
  }, [topbarTheme, dispatch]);

  // Auto-hide sidebar functionality - COMMENTED OUT
  // Sidebar will only be compacted manually by user, not automatically
  // useEffect(() => {
  //   // Don't auto-hide if user has manually overridden
  //   if (manualOverride) {
  //     return;
  //   }
  //   
  //   const currentPath = location.pathname;
  //   
  //   // Dashboard routes that should show expanded sidebar
  //   const dashboardRoutes = [
  //     '/Dashboard',
  //     '/DefaultDashboard', 
  //     '/GmsSpaEmployeeDashboard',
  //     '/GmsSpaManagerFinanceDashboard'
  //   ];
  //   
  //   // Check if current path is a dashboard route
  //   const isDashboardRoute = dashboardRoutes.includes(currentPath);
  //   
  //   // Auto-collapse sidebar for non-dashboard routes, auto-expand for dashboard routes
  //   if (isDashboardRoute) {
  //     // Dashboard: Show expanded sidebar
  //     if (leftSideBarType === "condensed") {
  //       dispatch(changeSidebarType("default", isMobile));
  //     }
  //   } else {
  //     // Other pages: Show collapsed sidebar
  //     if (leftSideBarType === "default") {
  //       dispatch(changeSidebarType("condensed", isMobile));
  //     }
  //   }
  // }, [location.pathname, leftSideBarType, dispatch, isMobile, manualOverride]);

  // Reset manual override when navigating to dashboard - COMMENTED OUT
  // useEffect(() => {
  //   const currentPath = location.pathname;
  //   const dashboardRoutes = [
  //     '/Dashboard',
  //     '/DefaultDashboard', 
  //     '/GmsSpaEmployeeDashboard',
  //     '/GmsSpaManagerFinanceDashboard'
  //   ];
  //   
  //   if (dashboardRoutes.includes(currentPath)) {
  //     setManualOverride(false);
  //   }
  // }, [location.pathname]);

  return (
    <React.Fragment>

      <div id="layout-wrapper">
        <Header toggleMenuCallback={toggleMenuCallback} />
        <Sidebar
          theme={leftSideBarTheme}
          type={leftSideBarType}
          isMobile={isMobile}
        />
        <div className="main-content">{props.children}</div>
        <Footer />
      </div>
      {showRightSidebar ? <RightSidebar /> : null}
      <SpaAssistant />
    </React.Fragment>
  );
};

Layout.propTypes = {
  changeLayoutWidth: PropTypes.func,
  changeSidebarTheme: PropTypes.func,
  changeSidebarThemeImage: PropTypes.func,
  changeSidebarType: PropTypes.func,
  changeTopbarTheme: PropTypes.func,
  children: PropTypes.any,
  isPreloader: PropTypes.any,
  layoutWidth: PropTypes.any,
  leftSideBarTheme: PropTypes.any,
  leftSideBarThemeImage: PropTypes.any,
  leftSideBarType: PropTypes.any,
  location: PropTypes.object,
  showRightSidebar: PropTypes.any,
  topbarTheme: PropTypes.any,
};

export default withRouter(Layout);
